module.exports = __webpack_public_path__ + "img/network-map.f7b95797.png";